var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'cz2__panel-header',
        'cz3__panel-header--' + _vm.align ]},[_c('div',{staticClass:"cz2__type__small-header",domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.subtitle !== null)?_c('div',{staticClass:"cz2__type__micro cz2__text--center hide--above-sm cz2__panel-header__sub-title",domProps:{"innerHTML":_vm._s(_vm.subtitle)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }